import { Heading } from './Heading';

type Props = {
  title: string;
};

export function MobileNavbar({ title }: Props): React.ReactElement {
  return (
    <div className="block lg:hidden">
      <nav className="min-h-16 bg-primary-600 flex items-center justify-center absolute text-zinc-50 w-full left-0 top-0">
        <Heading variant="h2" className="text-3xl">
          {title}
        </Heading>
      </nav>
      <div className="h-16" />
    </div>
  );
}
